import { lazy } from "react";
import LandingPageLayout from "../../layouts/LandingPageLayout";
import { AppRoute } from "../../../types/common";
import Solutions from "../landing/sections/solutions/Solutions";
import ProductsAndServices from "../landing/sections/products/ProductsAndServices";
import Resources from "../landing/sections/resources/Resources";
import LegalOverview from "../landing/sections/legal/LegalOverview";

const Login = lazy(() => import("./LoginPage"));
const OnboardingPage = lazy(() => import("./OnboardingPage"));
const ResetPassword = lazy(() => import("./ResetPassword"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const OtpVerification = lazy(() => import("./OtpVerification"));
const SetPin = lazy(() => import("./SetPin"));
const ChangePassword = lazy(() => import("./ChangePassword"));
const Services = lazy(() => import("../landing/sections/Services"));
const FAQ = lazy(() => import("../landing/sections/resources/FAQ"));
const AboutUs = lazy(() => import("../landing/sections/aboutUs/AboutUs"));
const ContactUs = lazy(() => import("../landing/sections/ContactUs"));
const Landing = lazy(() => import("../landing/Landing"));
const ApplicationPage = lazy(() => import("./ApplicationPage"));
const CheckStatus = lazy(() => import("../landing/sections/CheckStatus"));

const AuthRoutes: AppRoute[] = [
  {
    path: "/",
    component: <LandingPageLayout />,
    children: [
      { index: true, component: <Landing /> },

      { path: "about", component: <AboutUs /> },
      { path: "about/vision-mission", component: <AboutUs /> },

      { path: "our-services", component: <Services /> },
      { path: "contact", component: <ContactUs /> },
      { path: "faq", component: <FAQ /> },
      { path: "check-status", component: <CheckStatus /> },

      {
        path: "application/:applicationType",
        component: <ApplicationPage />,
      },

      { path: "solutions", component: <Solutions /> },
      { path: "products-services", component: <ProductsAndServices /> },

      { path: "resources", component: <Resources /> },
      {
        path: "/login",
        component: <Login />,
        exact: true,
      },
      {
        path: "/otp-verification",
        component: <OtpVerification />,
        exact: true,
      },
      {
        path: "/change-password",
        component: <ChangePassword />,
        exact: true,
      },
      {
        path: "/set-pin",
        component: <SetPin />,
        exact: true,
      },
      {
        path: "/register",
        component: <OnboardingPage />,
        exact: true,
      },

      {
        path: "/forgot-password",
        component: <ForgotPassword />,
        exact: true,
      },
      {
        path: "/password-reset/:token",
        component: <ResetPassword />,
        exact: true,
      },
      {
        path: "/application/:applicationType",
        component: <ApplicationPage />,
        exact: true,
      },
      {
        path: "/legal",
        component: <LegalOverview />,
        exact: true,
      },
    ],
  },
];

export default AuthRoutes;
